
import { computed, defineComponent, ref } from 'vue';
import { ComponentName } from '@/products/api/configuration/components/ComponentName';
import { setupComponent } from '@/products/composables/setupComponent';

import InjectStyles from '@/common/components/InjectStyles.vue';
import AttributesTable from '@/common/components/AttributesTable.vue';
import { DetailDataTypeEnum } from '@/common/services/swagger/index.defs';

export default defineComponent({
  name: ComponentName.detailsGeneralInformation,

  components: {
    InjectStyles,
    AttributesTable,
  },

  props: {
    instanceId: String,
  },

  setup(props) {
    const root = ref<HTMLElement>();

    const { instance, componentName, isReady, isWebComponent, store, t } = setupComponent(
      root,
      props.instanceId,
      [DetailDataTypeEnum.ProductDetails],
    );

    const item = computed(() => store.value?.data.productDetail?.item);

    const hideDocumentLinks = computed(
      () => store.value?.options.components?.common?.hideDocumentLinks == true,
    );

    return {
      root,
      componentName,
      isReady,
      isWebComponent,
      store,
      instance,
      item,
      hideDocumentLinks,
      t,
    };
  },
});
